import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CognitoAuthService } from '../cognito-auth.service';

/**
 * Guard per proteggere le rotte che richiedono autenticazione Cognito.
 * Se l'autenticazione non è abilitata, permette l'accesso.
 * Se l'utente non è autenticato, reindirizza a Cognito Hosted UI.
 */
export const cognitoAuthGuard: CanActivateFn = () => {
    const authService = inject(CognitoAuthService);
    const router = inject(Router);

    // Se Cognito non è abilitato, permetti l'accesso
    if (!authService.isEnabled) {
        return true;
    }

    // Controlla se l'utente è autenticato
    if (authService.isAuthenticated()) {
        return true;
    }

    // Se non autenticato, salva l'URL richiesto e reindirizza al login
    const currentUrl = router.url;
    if (currentUrl !== '/auth/callback') {
        sessionStorage.setItem('cognito_redirect_url', currentUrl);
    }

    authService.login();
    return false;
};
